module.exports = __webpack_public_path__ + "static/img/14000523.393d8255.png";